<script>
import { onMount } from "svelte";
import { navigate } from "svelte-routing";

onMount(() => {
    window.localStorage.removeItem('authToken');
    navigate('/');
});
</script>
